import { render, staticRenderFns } from "./action-prompt.vue?vue&type=template&id=59147a5d&scoped=true"
import script from "./action-prompt.vue?vue&type=script&lang=js"
export * from "./action-prompt.vue?vue&type=script&lang=js"
import style0 from "./action-prompt.vue?vue&type=style&index=0&id=59147a5d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59147a5d",
  null
  
)

export default component.exports